export const iconFontAwesomeCommunicationSquarePhoneFlip = (
	<i className="fa-solid fa-square-phone-flip"></i>
);
